const baseURL = 'www.baidu.com'
const token = '123456'
const viewData = null
const curPage = 0
const defaultProj = ['1085', '113.118638', '25.802413']
const eTotal = 0

const totalData = [{ name: '郴州市', size: 9440 }, { name: '阜阳市', size: 20177 }, { name: '临泉县', size: 2612 }, { name: '清远市', size: 13833 }, { name: '邵阳市', size: 8861 }]

const czName = ['苏仙区', '北湖区', '资兴市', '桂阳县', '宜章县', '永兴县', '嘉禾县', '临武县', '汝城县', '桂东县', '安仁县']
const czData = [4198, 1524, 731, 405, 493, 410, 271, 346, 105, 509, 448]

const lqName = ['临泉县']
const lqData = [2612]
// const lqName = ['双清区', '大祥区', '北塔区', '邵东县', '新邵县', '邵阳县', '隆回县', '洞口县', '绥宁县', '新宁县', '城步县', '武冈市'] //数据有问题
// const lqData = [2612, 687, 524, 273, 338, 496, 460, 710]

const fyName = ['颍州区', '颍东区', '颍泉区', '临泉县', '太和县', '阜南县', '颍上县', '界首市']
const fyData = [5691, 1615, 2117, 2612, 3255, 1591, 1627, 1669]

const syName = ['双清区', '大祥区', '北塔区', '邵东县', '新邵县', '邵阳县', '隆回县', '洞口县', '绥宁县', '新宁县', '城步县', '武冈市']
const syData = [1062, 1678, 686, 1299, 648, 687, 524, 273, 338, 496, 460, 710]

const qyName = ['清城区', '清新区', '佛冈县', '英德市', '连州市', '连山县', '连城县', '阳山县']
const qyData = [7520, 1593, 895, 2059, 651, 131, 177, 733]

const areaData = [
  {
    city: '郴州市',
    total: 9440,
    area: [
      { name: '苏仙区', total: 4198 },
      { name: '资兴市', total: 731 },
      { name: '北湖区', total: 1351 },
      { name: '安仁县', total: 405 },
      { name: '桂阳县', total: 493 },
      { name: '永兴县', total: 410 },
      { name: '宜章县', total: 271 },
      { name: '嘉禾县', total: 346 },
      { name: '临武县', total: 105 },
      { name: '汝城县', total: 509 },
      { name: '桂东县', total: 448 }
    ]
  },
  {
    city: '阜阳市',
    total: 20177,
    area: [
      { name: '颍州区', total: 5691 },
      { name: '颍东区', total: 1615 },
      { name: '颍泉区', total: 2117 },
      { name: '临泉县', total: 2612 },
      { name: '太和县', total: 3255 },
      { name: '阜南县', total: 1591 },
      { name: '颍上县', total: 1627 },
      { name: '界首市', total: 1669 }
    ]
  },
  {
    city: '临泉县',
    total: 2612,
    area: [
      { name: '颍州区', total: 2410 },
      { name: '颍东区', total: 687 },
      { name: '颍泉区', total: 524 },
      { name: '临泉县', total: 273 },
      { name: '太和县', total: 338 },
      { name: '阜南县', total: 496 },
      { name: '颍上县', total: 460 },
      { name: '界首市', total: 710 }
    ]
  },
  {
    city: '清远市',
    total: 13833,
    area: [
      { name: '连州市', total: 7520 },
      { name: '连南瑶族自治县', total: 1593 },
      { name: '连山壮族瑶族自治县', total: 895 },
      { name: '阳山县', total: 2059 },
      { name: '英德市', total: 651 },
      { name: '清新区', total: 131 },
      { name: '清城区', total: 177 },
      { name: '佛冈县', total: 733 }
    ]
  },
  {
    city: '邵阳市',
    total: 8861,
    area: [
      { name: '双清区', total: 1062 },
      { name: '大祥区', total: 1678 },
      { name: '北塔区', total: 686 },
      { name: '邵东县', total: 1299 },
      { name: '新邵县', total: 648 },
      { name: '邵阳县', total: 687 },
      { name: '隆回县', total: 524 },
      { name: '洞口县', total: 273 },
      { name: '绥宁县', total: 338 },
      { name: '新宁县', total: 496 },
      { name: '城步苗族自治县', total: 460 },
      { name: '武冈市', total: 710 }
    ]
  }
]

function isLogin() {
  if (sessionStorage.getItem('isLogin') != null && sessionStorage.getItem('isLogin') === '1') {
    return true
  }
  return false
}

function getKeyType() {
  var keytype = 0
  if (localStorage.getItem('keytype') != null) {
    return parseInt(localStorage.getItem('keytype'))
  }
  return keytype
}
// const eData = [
//   {name:'北胡区',value:'4198'}
// ]
export default {
  baseURL,
  token,
  viewData,
  curPage,
  defaultProj,
  totalData,
  czName,
  czData,
  lqName,
  lqData,
  fyName,
  fyData,
  syName,
  syData,
  qyName,
  qyData,
  eTotal,
  areaData,
  isLogin,
  getKeyType
}



// WEBPACK FOOTER //
// ./src/api/global_variable.js